/**************************************************
 * Nombre:       Dialogo_Lead
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Lead_Datos from "../Formularios/Formulario_Lead_Datos";
import Formulario_Estado from "../Formularios/Formulario_Estado";
import {usePestanasFormularios} from "../Hooks/usePestanasFormularios";
import Formulario_Lead_Intereses from "../Formularios/Formulario_Lead_Intereses";
import Formulario_Lead_Contactos from "../Formularios/Formulario_Lead_Contactos";
import Formulario_Lead_Comentarios from "../Formularios/Formulario_Lead_Comentarios";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {obtenerProximoContacto} from "../Funciones/obtenerProximoContacto";

const Dialogo_Lead = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    let Pestanas;
    ({Pestanas} = usePestanasFormularios({
        pestanas: ['Datos', 'Intereses', 'Citas Tel', 'Comentarios'],
        Formularios: [
            <Formulario_Lead_Datos props={props}/>,
            <Formulario_Lead_Intereses props={props}/>,
            <Formulario_Lead_Contactos props={props}/>,
            <Formulario_Lead_Comentarios props={props}/>
        ]
    }));
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {


        let entidad = await obtenerEntidad()
        console.log(entidad)

        iniciarCarga('Subiendo Datos')
        let doxImg = await subirImagenHostingFile(entidad.img)
        entidad.img = doxImg.data

        //Colocar proximo contacto
        entidad.fechaProximoContacto = obtenerProximoContacto(entidad.contactos)

        let dox = await guardarDoc('potenciales', entidad)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('potenciales', datos.id)
        terminar({aviso: 'Lead borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                <Formulario_Estado props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Pestanas/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Lead